import { useEffect } from 'react';

// Título y descripción por página pública. Restaura los valores anteriores al
// salir para que las pantallas privadas no hereden el título de la landing.
const ORIGEN = 'https://monimex.com.mx'; // cambiar con el dominio definitivo (igual que index.html)

export function usePageMeta(title, description, { noindex = false } = {}) {
  useEffect(() => {
    // Canonical por ruta: el estático de index.html apuntaba todas las rutas a "/"
    const canon = document.querySelector('link[rel="canonical"]');
    const canonPrevio = canon ? canon.getAttribute('href') : null;
    if (canon) canon.setAttribute('href', ORIGEN + window.location.pathname);
    let robots = null;
    if (noindex) {
      robots = document.createElement('meta');
      robots.setAttribute('name', 'robots');
      robots.setAttribute('content', 'noindex');
      document.head.appendChild(robots);
    }
    const tituloPrevio = document.title;
    const meta = document.querySelector('meta[name="description"]');
    const descPrevia = meta ? meta.getAttribute('content') : null;
    if (title) document.title = title;
    if (meta && description) meta.setAttribute('content', description);
    return () => {
      if (canon && canonPrevio !== null) canon.setAttribute('href', canonPrevio);
      if (robots) robots.remove();
      document.title = tituloPrevio;
      if (meta && descPrevia !== null) meta.setAttribute('content', descPrevia);
    };
  }, [title, description, noindex]);
}
